module.exports = __webpack_public_path__ + "img/jr29.300f490a.jpg";